import { environment } from "../../environment";
import { getApiEndpoint } from "../../utils/constants/api";
import { PAGE_TEMPLATES, CONTENT_SITE_PAGE_TEMPLATES } from "../../utils/constants/templates";
import { wfetch } from "../../utils/fetch";

export const FETCH_DYNAMIC_PAGES = "FETCH_DYNAMIC_PAGES";

export const fetchDynamicPages = (appBase = environment.APP_BASE) => {
    return async (dispatch, getState) => {
        const contentSitePath = getState().rootPageData?.contentSite?.["@path"];

        const [dynamicPages, contentSiteDynamicPages] = await Promise.all([
            fetchPagePathsByTemplate(appBase, [PAGE_TEMPLATES.PRODUCT_DETAIL, PAGE_TEMPLATES.PRODUCT_OVERVIEW]),
            contentSitePath ? fetchPagePathsByTemplate(contentSitePath, Object.values(CONTENT_SITE_PAGE_TEMPLATES).flat()) : null,
        ]);

        dispatch({
            type: FETCH_DYNAMIC_PAGES,
            payload: { ...dynamicPages, ...contentSiteDynamicPages },
        });
    };
};

const fetchPagePathsByTemplate = async (ancestor, templates) => {
    const response = await wfetch(
        getApiEndpoint("PAGES", {
            pathParams: { path: "" },
            queryParams: {
                "@ancestor": ancestor,
                "mgnl:template": `${templates.join("|")}`,
            },
        }),
    );

    if (!response) return;

    return Object.fromEntries(response.data.results.map((r) => [r["mgnl:template"], r["@path"]]));
};
